export default __webpack_public_path__ + "assets/Mantenimiento.gif";